import React from 'react';
import { SvgIcon } from '../components/svgIcon';
import { SvgIconProps } from '../components/svgIcon/model';

export const HeartBoldIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="heartBold" ref={ref as any} {...props}>
      <path
        d="M19.4414 8.84863C19.4414 7.01553 18.0157 5.57718 16.2354 5.57715C14.6284 5.57715 13.7558 6.53433 12.96 7.45215L12 8.60742L11.04 7.45215L10.7363 7.1084C10.0142 6.31035 9.17074 5.57715 7.76465 5.57715C5.98429 5.57718 4.55859 7.01553 4.55859 8.84863C4.55862 10.082 4.92513 11.1173 6.07129 12.4951C7.20057 13.8526 9.05623 15.5037 12 17.9482C14.9438 15.5037 16.7994 13.8526 17.9287 12.4951C19.0749 11.1173 19.4414 10.082 19.4414 8.84863ZM21.5 8.84863C21.5 10.5965 20.9853 12.0121 19.6064 13.6973C18.254 15.3501 16.0446 17.2911 12.6396 20.1113L12.6406 20.1123L12.3232 20.3818L12 20.6553L11.6768 20.3818L11.3594 20.1123C7.9548 17.2923 5.74597 15.35 4.39355 13.6973C3.01469 12.0121 2.50003 10.5965 2.5 8.84863C2.5 5.88716 4.83329 3.50003 7.76465 3.5C9.84211 3.5 11.1298 4.54027 12 5.46289C12.8702 4.54027 14.1579 3.5 16.2354 3.5C19.1667 3.50003 21.5 5.88716 21.5 8.84863Z"
        fill="#405368"
      />
    </SvgIcon>
  );
});
